/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AnswerInputDto model module.
 * @module model/AnswerInputDto
 * @version v0
 */
class AnswerInputDto {
    /**
     * Constructs a new <code>AnswerInputDto</code>.
     * Answer object to create
     * @alias module:model/AnswerInputDto
     * @param content {String} 
     * @param isCorrect {Boolean} 
     * @param questionId {Number} 
     */
    constructor(content, isCorrect, questionId) { 
        
        AnswerInputDto.initialize(this, content, isCorrect, questionId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, content, isCorrect, questionId) { 
        obj['content'] = content;
        obj['is_correct'] = isCorrect;
        obj['question_id'] = questionId;
    }

    /**
     * Constructs a <code>AnswerInputDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AnswerInputDto} obj Optional instance to populate.
     * @return {module:model/AnswerInputDto} The populated <code>AnswerInputDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AnswerInputDto();

            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('is_correct')) {
                obj['is_correct'] = ApiClient.convertToType(data['is_correct'], 'Boolean');
            }
            if (data.hasOwnProperty('question_id')) {
                obj['question_id'] = ApiClient.convertToType(data['question_id'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AnswerInputDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AnswerInputDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AnswerInputDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }

        return true;
    }


}

AnswerInputDto.RequiredProperties = ["content", "is_correct", "question_id"];

/**
 * @member {String} content
 */
AnswerInputDto.prototype['content'] = undefined;

/**
 * @member {Boolean} is_correct
 */
AnswerInputDto.prototype['is_correct'] = undefined;

/**
 * @member {Number} question_id
 */
AnswerInputDto.prototype['question_id'] = undefined;






export default AnswerInputDto;

